// extracted by mini-css-extract-plugin
export var active = "_2k-7";
export var backButton = "_2k-6";
export var clone = "_2k-c";
export var collapseBar = "_2k-h";
export var collapseMode = "_2k-j";
export var collapsed = "_2k-l";
export var dragHandle = "_2k-a";
export var dropdownIcon = "_2k-e";
export var expanding = "_2k-k";
export var hidden = "_2k-r";
export var iconContainer = "_2k-o";
export var iconSwapper = "_2k-q";
export var navItem = "_2k-4";
export var navItemIcon = "_2k-d";
export var navProfile = "_2k-5";
export var notificationCountBadge = "_2k-g";
export var notificationDot = "_2k-p";
export var optionsContainer = "_2k-f";
export var primaryNav = "_2k-0";
export var primaryTab = "_2k-m";
export var secondaryNav = "_2k-1";
export var selected = "_2k-n";
export var settingsNav = "_2k-2";
export var settingsNavItems = "_2k-3";
export var show = "_2k-b";
export var sideNav = "_2k-i";
export var teamItem = "_2k-8";
export var userProfileItem = "_2k-9";